export const getUrlQueryStringPart = (params) => {
    const queryString = Object.keys(params)
        .map((key) => {
        if (params[key] !== undefined) {
            if (Array.isArray(params[key])) {
                return params[key]
                    .map((value) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
            }
            if (typeof params[key] === 'object') {
                const objectParams = JSON.stringify(params[key]);
                return `${key}=${encodeURIComponent(objectParams)}`;
            }
            return `${key}=${params[key]}`;
        }
        return '';
    })
        .filter((item) => item)
        .join('&');
    return queryString ? `?${queryString}` : '';
};
